import { createClient } from "@supabase/supabase-js";
import { config } from "../utils/config";

const supabaseUrl = config.SUPABASE_URL
const supabaseAnonKey = config.SUPABASE_PUBLISHABLE_KEY


if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error("Missing Supabase environment variables!");
}

const supabase = createClient(supabaseUrl, supabaseAnonKey);

export default supabase;
